<template>
  <div>
    <div class="room-select__top__title" :class="{ 'active-title': isActive }">
      {{ $t("booking.room_and_guests") }}
    </div>
    <div class="room-select__top">
      <div class="room-select__top__select-box" @click="showRoomSelect">
        <div class="person-icon">
          <span>{{ totalGuest }}</span>
        </div>
        <div class="text">{{ $t("booking.select") }}</div>
      </div>
    </div>
    <div class="room-select__mobile" @click="showRoomSelect">
      <div class="person-icon">
        <span class="icon-Icon-People-2" />
      </div>
      <div class="guest-stats">
        {{ roomList.length }}
        {{ roomList.length > 1 ? $t("booking.rooms") : $t("booking.rooms") }} ,
        {{ totalGuest }}
        {{ totalGuest > 1 ? $t("booking.guests") : $t("booking.guest") }}
      </div>
      <div class="plus-icon">
        <span class="icon-Arrow-Plus" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "RoomSelectButton",
  props: {
    isActive: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      totalGuest: "totalGuest",
    }),
    ...mapState({
      roomList: state => state.roomList,
    }),
  },
  methods: {
    ...mapActions({
      showRoomSelect: "showRoomSelect",
    }),
  },
};
</script>

<style lang="scss" scoped>
.room-select {
  &__top {
    display: none;
    @include min-sm {
      display: block;
    }
    &__title {
      display: none;
      color: #232e48;
      font-size: 13px;
      margin-bottom: 12px;
      text-align: center;
      @include min-sm {
        display: block;
        white-space: nowrap;
      }
    }
    &__select-box {
      position: relative;
      height: 60px;
      border: 2px solid #e4e4e7;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      cursor: pointer;
      &::after {
        content: "";
        right: 1px;
        bottom: 1px;
        position: absolute;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-top: 5px solid #ffd25d;
        border-right: 5px solid #ffd25d;
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }
      .person-icon {
        font-weight: bold;
        .icon-Icon-Person {
          font-weight: bold;
        }

        span{
          font-size: 15px;
        }
      }
    }

    .text {
      font-size: 12px;
      color: #a5a5ac;
    }
  }

  &__mobile {
    position: relative;
    height: 50px;
    border: 2px solid #dddee0;
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #232e48;
    @include min-sm {
      display: none;
    }

    .person-icon {
      margin-left: 15px;
    }

    .guest-stats {
      margin-left: 15px;
      font-size: 14px;
    }

    .plus-icon {
      flex-grow: 1;
      text-align: right;
      padding-right: 15px;
    }

    .icon-Arrow-Plus {
      font-size: 13px;
      font-weight: bold;
    }
  }
}
</style>
